@if (content$ | async; as vm) {
    <ms-widget-slot msModalDialogContainer [widget]="vm.widgets" [page]="vm.page" [layoutTemplate]="vm.layoutTemplate" />
}
